module.exports = __webpack_public_path__ + "img/2009 feuerwehr winteressen 010.01b8bb2a.jpg";